// extracted by mini-css-extract-plugin
export default {"root":"yw_9oDmpDA","from":"ZdHwMcwNZS","emailDate":"z3N6ZLnd8B"};